<template>
  <div v-if="submenu != null">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">{{ submenu.name }}</h2>
        </div>
      </div>
    </div>
    <div v-if="submenu.contents[0].imageList != null">
      <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li
            v-for="(image, i) in submenu.contents[0].imageList"
            :key="i"
            data-target="#carouselExampleIndicators"
            :data-slide-to="i"
            :class="{ 'active': i == 0 }"
          ></li>
        </ol>
        <div class="carousel-inner">
          <div
            v-for="(image, i) in submenu.contents[0].imageList"
            :key="i"
            class="carousel-item"
            :class="{ 'active': i == 0 }"
          >
            <img class="d-block w-100" v-bind:src="image" alt="First slide">
          </div>
        </div>
        <a
          class="carousel-control-prev"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          href="#carouselExampleIndicators"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <div v-if="submenu.contents[0].description != null">
      <br>
      {{ submenu.contents[0].description }}
    </div>
    <div>
      <Article v-if="submenu.layout == 1" :parent-id="parentId" :entries="entries"/>
      <ArticleNoThumb v-else-if="submenu.layout == 2" :parent-id="parentId" :entries="entries"/>
      <CardInfo v-else-if="submenu.layout == 3" :parent-id="parentId" :entries="entries"/>
      <Branch v-else-if="submenu.layout == 4" :parent-id="parentId" :entries="entries"/>
    </div>
  </div>
</template>

<script>
import Article from "@/components/layout/Article.vue";
import ArticleNoThumb from "@/components/layout/ArticleNoThumb.vue";
import Branch from "@/components/layout/Branch.vue";
import CardInfo from "@/components/layout/CardInfo.vue";
import MenuService from "@/services/MenuService";

export default {
  components: {
    Article,
    ArticleNoThumb,
    Branch,
    CardInfo
  },

  created() {
    this.$store.dispatch("setLoading", true);
    this.getEntries();
  },

  computed: {
    parentId() {
      return this.$route.params.parentId;
    },

    entries() {
      return this.submenu.childEntries.rows;
    }
  },

  data() {
    return {
      submenu: null
    };
  },

  methods: {
    getEntries() {
      MenuService.viewEntry({}, this.parentId).then(response => {
        if (response.status == 200 && response.data.success == true) {
          this.submenu = response.data.payload;
        }

        this.$store.dispatch("setLoading", false);
      });
    }
  }
};
</script>
